var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyViewIconSubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.5604 25.0604 31.5 16.5 31.5C7.93959 31.5 1 24.5604 1 16C1 7.43959 7.93959 0.5 16.5 0.5C25.0604 0.5 32 7.43959 32 16Z",
    fill: "#D4D9E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 8.94531L17.0605 20.0098H14.9336L14.7402 8.94531H17.2539ZM14.4824 23.125C14.4717 22.2871 15.1699 21.5996 16.0078 21.5996C16.835 21.5996 17.5225 22.2871 17.5332 23.125C17.5225 23.9629 16.835 24.6396 16.0078 24.6504C15.1699 24.6396 14.4717 23.9629 14.4824 23.125Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyViewIconSubmit);
export default __webpack_public_path__ + "static/media/EmptyViewIconSubmit.29ea2d59ae6a74ca3e5d36e184dc6704.svg";
export { ForwardRef as ReactComponent };